module.exports = __webpack_public_path__ + "img/shoot_00008.766fdaf1.png";